module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-navy-1-bcdc464a550170a98e310901ca116af9.webp";